import React, { useState, useEffect } from 'react';
import {ReactComponent as Segmentation_people} from '../Layer_images/Settings_images/segmentation_people.svg'
import {ReactComponent as Segmentation_calendar} from '../Layer_images/Settings_images/segmentation_calendar.svg'
import {ReactComponent as Segmentation_dollar} from '../Layer_images/Settings_images/segmentation_dollar.svg'


const age_mappings = {
    'under_18': 'Youth',
    '18_24': 'Young Adults',
    '25_34': 'Establishing Adults',
    '35_44': 'Mid-Career Adults',
    '45_54': 'Established Adults',
    '55_64': 'Pre-Retiree',
    '65_plus': 'Retired'
}

const age_segments = {
    'under_18': 'Under 18',
    '18_24': '18 - 24',
    '25_34': '25 - 34',
    '35_44': '35 - 44',
    '45_54': '45 - 54',
    '55_64': '55 - 64',
    '65_plus': '65+'
}

const income_segments = {
    'low_income': '$0-30,000',
    'lower_middle_income': '$30,000-50,000',
    'middle_income': '$50,000-75,000',
    'upper_middle_income': '$75,000-125,000',
    'high_income': '$125,000-200,000',
    'very_high_income': '$200,000+'
}

const income_mapping = {
    low_income: 'Essential Income',
    lower_middle_income: 'Building Income',
    middle_income: 'Stable Income',
    upper_middle_income: 'Comfortable Income',
    high_income: 'Affluent Income',
    very_high_income: 'Elite Income',
}

const region_mapping = {
    Urban_Core: 'Metro',
    Urban: 'City',
    Suburban: 'Suburbs',
    Rural: 'Rural'
}

const age_options = [
    {label: 'Under 18', value: 'under_18'},
    {label: '18-24', value: '18_24'},
    {label: '25-34', value: '25_34'},
    {label: '35-44', value: '35_44'},
    {label: '45-54', value: '45_54'},
    {label: '55-64', value: '55_64'},
    {label: '65+', value: '65_plus'},
];

const income_options = [
    {label: '$0-30k', value: 'low_income'},
    {label: '$30k-50k', value: 'lower_middle_income'},
    {label: '$50k-75k', value: 'middle_income'},
    {label: '$75k-125k', value: 'upper_middle_income'},
    {label: '$125k-200k', value: 'high_income'},
    {label: '$200k+', value: 'very_high_income'},
];

const region_options = [
    {label: 'Metro', value: 'Urban Core'},
    {label: 'City', value: 'Urban'},
    {label: 'Suburbs', value: 'Suburban'},
    {label: 'Rural', value: 'Rural'},
];

export const CompetitorMarketSegmentation = ({competitor, topLineClass}) => {
    const [marketSegmentations, setMarketSegmentations] = useState([]);


    const handleCompetitorChange = (competitor) => {
        const agg_values = {}
        var final_values = [];
        competitor.map((com) => {
            let segments = com?.segmentation?.segmentOverview;
            if(segments){
                Object.entries(segments).forEach(([key, value]) => {
                    if(agg_values[key]){
                        agg_values[key] += value;
                    }else{
                        agg_values[key] = value;
                    }
                });

            }
        })
        Object.entries(agg_values).forEach(([key, value]) => {
            if(key.includes('under_18')) return;
            key = key.replace('Urban Core', 'Urban_Core')
            key = key.split(' ');
            final_values.push({total_pop: value, age_group: key[0], income_group: key[1], region_type: key[2]})
        })
        console.log('final_values: ', final_values)
        final_values = final_values.sort((a, b) => (b?.total_pop || 0) - (a?.total_pop || 0)).slice(0, 10);
        setMarketSegmentations(final_values);
    }

    useEffect(() => {
        handleCompetitorChange(competitor);
    }, [competitor]);

    const get_image_link = (age, income) => {
        var income_value = 1;
        if(age != 'under_18'){
    
         const income_mapping = { 'low_income': 1, 'lower_middle_income': 2, 'middle_income': 3, 'upper_middle_income': 4, 'high_income':5,  'very_high_income': 6}
         income_value = income_mapping[income]
        }
        
        return `segmentation/${age}_${income_value}.jpeg`
    }

    function formatNumber(value) {
        // Check if the value is a number
        if (typeof value === 'number' || (typeof value === 'string' && !isNaN(value))) {
          // Convert to number to handle string numbers, then to string for formatting
          return Number(value).toLocaleString();
        } else {
          // Return the original value if it's not a number
          return value;
        }
    }


    return (
        <div>
            <div className={topLineClass} >
                <div className='box-container Competitor-market-segment'>
                <div class="Competitor-financials-title">Top Market Segmentations</div>
                {marketSegmentations.map((e) => (
                <div key={e.age_group + e.income_group + e.region_type} className='data-component'>
                
                <div className='box-container mtb-10 p-10'>
                    <div className='display-flex gap-10 sidbar-primary-text'>
                    {e.age_group && <div className='display-flex gap-10'><div >{age_mappings[e.age_group]}</div><div>•</div></div>}
                    {e.income_group && <div className='display-flex gap-10'><div>{income_mapping[e.income_group]}</div><div>•</div></div>}
                    {e.region_type && <div className='display-flex gap-10'><div>{region_mapping[e.region_type]}</div></div>}
                    </div>
                    <div className='display-flex gap-10  mtb-10 sidbar-primary-text'>
                    <img   src={get_image_link(e.age_group, e.income_group)}  className='segmentation-profile-image'/>
                    <div className="box-container">
                        <div className='segmentation-top-sidebar'>
                        <div className='display-inline-block pt-5'><Segmentation_people/></div>
                        <div className='display-inline-block font-size-10'>Number of People</div>
                        </div>
                        <div className='text-align-left pl-5' style={{color: '#1570EF'}}>{formatNumber(e.total_pop)}</div>
                    </div>
                    <div className="box-container">
                        <div className='segmentation-top-sidebar'>
                        <div className='display-inline-block pt-5'><Segmentation_calendar/></div>
                        <div className='display-inline-block font-size-10'>Age Group</div>
                        </div>
                        <div className='text-align-left pl-5' >{age_segments[e.age_group]}</div>
                    </div>
                    <div className="box-container">
                        <div className='segmentation-top-sidebar'>
                        <div className='display-inline-block pt-5'><Segmentation_dollar/></div>
                        <div className='display-inline-block font-size-10'>Income Group</div>
                        </div>
                        <div className='text-align-left pl-5' >{income_segments[e.income_group]}</div>
                    </div>
                    </div>
                </div>
                </div>
            ))}
            </div>
            </div>
    </div>
)
}